import {
  setConfig,
  setReadAppInsightsMethod,
  setReadStorageMethod,
  setWriteStorageMethod,
} from '@carecircle/core';
import loadable from '@loadable/component';
import { createRoot } from 'react-dom/client';
import LoadableFallback from './app/LoadableFallback';
import { getAppInsightsWeb, getStorageItem, setStorageItem } from './storage';
import { initializeWebTranslations } from './translations/initializeTranslations';

// try {
//   Sentry.init({
//     dsn: process.env.NX_PUBLIC_SENTRY_DSN,
//     integrations: [new Integrations.BrowserTracing()],

//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     // We recommend adjusting this value in production
//     tracesSampleRate: 1.0,
//   });
// } catch (e) {
//   console.error('Invalid sentry dsn');
// }

// Set up configuration from environment variables
setConfig(import.meta.env as Record<string, string>);

// Initialize platform-specific services
setWriteStorageMethod(setStorageItem);
setReadStorageMethod(getStorageItem);
setReadAppInsightsMethod(getAppInsightsWeb);

// Initialize web-specific translation configuration
initializeWebTranslations();

const AsyncRoot = loadable(() => import('./Root'), {
  fallback: (
    <div style={{ height: '100vh', backgroundColor: '#F2F9F8' }}>
      <LoadableFallback showLogoExtended noDelay />
    </div>
  ),
});
const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(<AsyncRoot />);
}
